import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useWorkspace } from "@/hooks/useWorkspace";
import { AgentTestChat } from "@/components/agents/AgentTestChat";
import { Button } from "@/components/ui/button";

export default function AgentsTest() {
  const { user } = useAuth();
  const { workspaceId, loading: workspaceLoading } = useWorkspace(user?.id);

  if (!workspaceId && workspaceLoading) {
    return <div>Carregando...</div>;
  }

  if (!workspaceId && !workspaceLoading) {
    return <div>Nenhum workspace encontrado.</div>;
  }

  return (
    <div className="flex h-full min-h-0 flex-col gap-4 px-4 py-4 sm:gap-5 sm:px-6 sm:py-6">
      <header className="flex shrink-0 items-start gap-4">
        <Button variant="ghost" size="icon" asChild className="mt-0.5 shrink-0">
          <Link to="/agents">
            <ArrowLeft className="h-5 w-5" />
          </Link>
        </Button>
        <div className="min-w-0">
          <h1 className="text-2xl font-bold sm:text-3xl">Teste de Agentes</h1>
          <p className="text-muted-foreground text-sm sm:text-base">
            Teste suas conversas com agentes de IA em tempo real
          </p>
        </div>
      </header>

      <div className="min-h-0 flex flex-1 flex-col">
        <AgentTestChat workspaceId={workspaceId} />
      </div>
    </div>
  );
}
